export default __webpack_public_path__ + "static/media/logo-spotify.7e255dc6.svg";